
import moment from 'moment'
import Util from 'service/util'

const today = Util.getToday()

const attachVehicleActiveService = (vehicle) =>
{
  vehicle.activeService = null
  if (!vehicle.services) return

  const filteredServices = vehicle.services.filter(
    x => (!x.end_dtm
      || moment(x.end_dtm).isSameOrAfter(today))
      && moment(x.start_dtm).isSameOrBefore(today)
  )

  vehicle.activeService = filteredServices[0] || null
}

export default Object.freeze({
  attachVehicleActiveService
})
